import { getStore } from '../store/store';
import { FileSuggestion } from 'owa-search-service';

export default function getSelectedSuggestion(): FileSuggestion | null {
    return getStore().suggestion;
}
